/* eslint-disable no-console */
import produce from 'immer';
import React, { createContext, Dispatch, useContext, useReducer } from 'react';

import {
  QueryListContextActions,
  QueryListContextActionTypes,
  QueryListContextProps,
  QueryListProviderProps,
} from './QueryListContext.types';

const QueryListContext = createContext<QueryListContextProps | undefined>(undefined);

const QueryListDispatchContext = createContext<Dispatch<QueryListContextActions> | undefined>(
  undefined,
);

const initialQueryListState: QueryListContextProps = {
  checkedQueryList: [],
};

const QueryListReducer = (state: QueryListContextProps, action: QueryListContextActions) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('ACTION SENT: ', action);
  }

  switch (action.type) {
    case QueryListContextActionTypes.UpdateCheckedQueryList: {
      return produce(state, (draft) => {
        draft.checkedQueryList = action.payload;
      });
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`);
    }
  }
};

export const QueryListContextProvider = ({ children }: QueryListProviderProps) => {
  const [state, dispatch] = useReducer(QueryListReducer, initialQueryListState);

  return (
    <QueryListContext.Provider value={state}>
      <QueryListDispatchContext.Provider value={dispatch}>
        {children}
      </QueryListDispatchContext.Provider>
    </QueryListContext.Provider>
  );
};

export const useQueryListState = () => {
  const context = useContext(QueryListContext);

  if (context === undefined) {
    throw new Error('QueryListState must be used within a QueryListProvider');
  }

  return context;
};

export const useQueryListDispatch = () => {
  const context = useContext(QueryListDispatchContext);

  if (context === undefined) {
    throw new Error('QueryListDispatch must be used within a QueryListProvider');
  }

  return context;
};
